import { FormattedMessage } from 'react-intl';
import { useSearchParams } from 'react-router';

export const SearchParametersShowLatestAppVersionsOnly = () => {
    const [searchParameters, setSearchParameters] = useSearchParams();
    const showLatestVersionsOnly = searchParameters.get('showLatestVersionsOnly');

    return (
        <div className="flex items-center" data-testid="search-parameters-show-all-app-versions">
            <input
                checked={showLatestVersionsOnly !== 'false'}
                className="h-4 w-4 rounded border-gray-200 text-indigo-600 shadow-sm focus:ring-indigo-600 disabled:opacity-50"
                id={'show-latest-apps-only'}
                onChange={(event) => {
                    const checked = event.target.checked;

                    if (checked) {
                        searchParameters.delete('showLatestVersionsOnly');
                    } else {
                        searchParameters.set('showLatestVersionsOnly', 'false');
                    }

                    searchParameters.delete('page');

                    setSearchParameters(searchParameters);
                }}
                type="checkbox"
            />
            <label className="ml-2 text-sm text-gray-700" htmlFor={'show-latest-apps-only'}>
                <FormattedMessage id={'APPS_PAGE_SHOW_LATEST'} />
            </label>
        </div>
    );
};
